import React from 'react';
import { motion } from 'framer-motion';
import { Element } from 'react-scroll';

const VisionMissionSection = () => {
  return (
    <Element name="vision" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl font-bold text-blue-600 mb-4">Our Vision & Mission</h2>
            <p className="text-gray-600 text-lg">Empowering innovation through accessible synthetic data</p>
          </motion.div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-blue-50 rounded-2xl p-8 shadow-lg"
            >
              <h3 className="text-2xl font-bold text-blue-600 mb-4">Our Vision</h3>
              <p className="text-gray-700 leading-relaxed">
                To improve the way data is created and utilized in AI development, making 
                high-quality synthetic data accessible to everyone. We envision a future where 
                data scarcity is no longer a barrier to innovation, and where AI development is 
                simplified through the power of synthetic data generation.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="bg-indigo-50 rounded-2xl p-8 shadow-lg"
            >
              <h3 className="text-2xl font-bold text-indigo-600 mb-4">Our Mission</h3>
              <p className="text-gray-700 leading-relaxed">
                To provide cutting-edge synthetic data generation tools that empower businesses, researchers, and developers to create high-quality datasets efficiently and ethically. We are committed to advancing AI development by solving the data scarcity problem while maintaining the highest standards of data quality and privacy.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </Element>
  );
};

export default VisionMissionSection; 